<style>
  .icon {
    width: inherit;
    height: inherit;
    margin: inherit;
  }
</style>

<svg class="icon" viewBox="162.712 132.034 153.512 145.421" xmlns="http://www.w3.org/2000/svg">
  <path style="stroke: rgb(0, 0, 0); stroke-width: 3px; fill: rgb(134, 178, 229);" d="M 239.413 136.43 C 199.013 136.43 166.263 158.828 166.263 183.05 C 166.263 202.029 186.524 218.157 214.732 224.198 C 216.405 239.7 213.236 265.063 205.109 274.58 C 217.361 261.472 230.449 239.359 235.23 226.706 C 236.604 226.706 238.039 226.821 239.413 226.821 C 279.813 226.821 312.504 207.215 312.504 183.05 C 312.504 158.885 279.813 136.43 239.413 136.43 Z"/>
  <rect y="150.677" width="43.338" height="3.63" style="fill: rgb(215, 235, 113);" x="192.122"/>
  <rect y="154.018" width="43.338" height="23.72" style="fill: rgb(228, 250, 123);" x="192.122"/>
  <rect y="150.404" width="43.338" height="3.63" style="fill: rgb(215, 235, 113);" x="243.839"/>
  <rect y="153.746" width="43.338" height="23.72" style="fill: rgb(228, 250, 123);" x="243.839"/>
  <rect y="184.253" width="43.338" height="3.63" style="fill: rgb(215, 235, 113);" x="192.293"/>
  <rect y="187.594" width="43.338" height="23.72" style="fill: rgb(228, 250, 123);" x="192.293"/>
  <rect y="183.98" width="43.338" height="3.63" style="fill: rgb(215, 235, 113);" x="244.012"/>
  <rect y="187.322" width="43.338" height="23.72" style="fill: rgb(228, 250, 123);" x="244.012"/>
</svg>